<template>
  <v-app :style="containerStyle">
    <Sidebar v-if="showSidebar" @update-is-closed="handleSidebarToggle" />
    <v-container>
      <!-- タイトル -->
      <v-col cols="12" class="header-section">
        <v-row>
          <h3>HOME</h3>
          <div class="search-field">
            <v-text-field v-model="searchQuery" clearable variant="underlined" label="検索" placeholder="検索"
            append-inner-icon="mdi-magnify" class="search-input" />
          </div>
        </v-row>
        <v-divider class="section-divider"></v-divider>
      </v-col>
      <!-- 画面一覧 -->
      <v-col cols="12" class="main-content">
        <v-row class="mt-10">
          <!-- screenIdがnullではない場合のみ表示 -->
          <v-col v-for="(item, index) in filteredMenuItems" :key="index" cols="3">
            <v-card class="custom-card" outlined @click="
              goToBasicPage(
                item.screenId,
                item.screenName,
                item.screenExplanation,
                item.tableId
              )
              " @contextmenu.prevent="showContextMenu($event, item)">
              <v-icon @click.stop class="mb-2" size="40">mdi-file-document-outline</v-icon>
              <v-card-title class="card-title">{{
                item.screenName
              }}</v-card-title>
              <v-card-subtitle class="card-subtitle">
                <span v-if="item.updatedUser"></span>
                {{ item.updatedUser }}
                <span v-if="item.updatedDate"> / </span>{{ getDaysAgo(item.updatedDate) }}
              </v-card-subtitle>
              <!-- 右クリックした時、表示 -->
              <v-menu v-model="item.iconVisible" :close-on-content-click="false" :style="{
                position: 'absolute',
                top: `${contextMenuPosition.y}px`,
                left: `${contextMenuPosition.x}px`,
              }" max-width="200px" transition="slide-x-reverse-transition">
                <v-btn color="red" icon="mdi-delete" @click="() => openDeleteDialog(item)">

                  <v-tooltip activator="parent" location="bottom">画面削除</v-tooltip>
                  <v-icon> mdi-delete</v-icon>
                </v-btn>
              </v-menu>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <!-- エラーメッセージ -->
      <div class="mt-10">
        <span id="ErrMsg" class="text-red" style="white-space: pre-wrap">
          {{ ErrMsg }}
        </span>
      </div>
    </v-container>
    <v-dialog v-model="deleteDialog" persistent max-width="400">
     <v-card>
      <v-card-title class="text-h6">パスワード確認</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="deletePassword"
          label="パスワード"
          type="password"
          required
        ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">キャンセル</v-btn>
          <v-btn color="red" @click="confirmDeleteWithPassword">確認</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import homeApi from "@/api/home";
import deleteApi from "@/api/delete";
import Sidebar from "@/components/Sidebar.vue";
import eventBus from "@/eventBus";

export default {
  name: "HomePage",
  components: {
    Sidebar,
  },
  mounted() {
    this.getDataFromApi();
    this.authUserId = localStorage.getItem("authUserId");
    this.sessionKey = localStorage.getItem("sessionKey");

    eventBus.on("refreshHomePage", this.getDataFromApi);
  },
  watch: {
    $route(to) {
      if (to.path.startsWith("/home")) {
        this.getDataFromApi();
      }
    },
  },

  data() {
    return {
      searchQuery: "",
      // authInfo: {
      //   authUserId: null,
      //   sessionKey: "",
      // },
      isSidebarClosed: false,
      showSidebar: true,
      menuItems: [
        //画面情報
        {
          screenId: null,
          tableId: null,
          screenName: "",
          screenExplanation: "",
          routeName: "screen",
          updatedUser: "",
          updatedDate: "",
          iconVisible: false,
        },
      ],
      items: [],
      contextMenuPosition: { x: 0, y: 0 },
      selectedItem: [],
      loading: false,
      ErrMsg: "",
      authUserId: null,
      sessionKey: "",
      staffName: "",
      deleteDialog: false,
      deletePassword: '',
    };
  },
  methods: {
    showAlert() {
      alert("この画面は削除または変更できません。");
    },
    goToBasicPage(screenId, screenName, screenExplanation, tableId) {
      console.log(
        "goToBasicPage Called",
        "screenId: ",
        screenId,
        "screenName: ",
        screenName,
        "screenExplanation :",
        screenExplanation,
        "tableId :",
        tableId
      );
      const screenData = {
        screenId: screenId,
        screenName: screenName,
        screenExplanation: screenExplanation,
        tableId: tableId,
      };
      sessionStorage.setItem("screenData", JSON.stringify(screenData));
      sessionStorage.setItem("tableId", tableId);

      this.$router.push({ path: `/${screenId}` });
    },
    handleSidebarToggle(isClosed) {
      this.isSidebarClosed = isClosed;
    },
    // APIからタスクリストを取得
    async getDataFromApi() {
      this.loading = true;
        try {
          this.authUserId = localStorage.getItem("authUserId");
          this.sessionKey = localStorage.getItem("sessionKey");
          this.staffName = localStorage.getItem("staffName");
          const result = await homeApi.getTaskList(
            this.authUserId,
            this.sessionKey,
            this.staffName
          );
          if (result.data) {
            this.items = result.data;
            this.ErrMsg = null;
            this.menuItems = [];
            for (var j = 0; j < this.items.length; j++) {
              this.addItem();
            }
            for (var i = 0; i < this.items.length; i++) {
              this.menuItems[i].screenId = this.items[i].screenId;
              this.menuItems[i].tableId = this.items[i].tableId;
              this.menuItems[i].screenName = this.items[i].screenName;
              this.menuItems[i].screenExplanation =
                this.items[i].screenExplanation;
              this.menuItems[i].updatedUser = this.items[i].updatedUser;
              this.menuItems[i].updatedDate = this.formatDate(
                this.items[i].updatedDate
              );
              this.menuItems[i].iconVisible = false;
            }

            //画面のデータがない場合
          } else {
            this.ErrMsg = "画面のデータが存在しません。" + result;
            this.items = [];
            this.menuItems = [];
          }
          //例外の場合
        } catch (error) {
          this.ErrMsg = "エラーが発生しました。\n" + error.message;
          this.items = [];
        }
        this.loading = false;
    },
    // メニューアイテムを追加
    addItem() {
      this.menuItems.push({
        screenId: null,
        tableId: null,
        screenName: "",
        screenExplanation: "",
        routeName: "",
        updatedUser: "",
        updatedDate: "",
      });
    },
    // 右クリックメニューを表示
    async showContextMenu(event, selecionItem) {
      this.selectedItem = selecionItem
      this.menuItems.forEach((item) => {
        item.iconVisible = false;
      });

      event.preventDefault();

      // スクロール位置を考慮したマウス位置をcontextMenuPositionに保存
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      this.contextMenuPosition = { x: event.pageX, y: event.pageY };

      selecionItem.iconVisible = await true;

      // メニューが画面外に出ないように制限
      const menuWidth = 200; // メニューの幅
      const menuHeight = 150; // メニューの高さ
      const windowWidth = document.documentElement.clientWidth;
      const windowHeight = document.documentElement.clientHeight;

      // メニューが画面右端を越える場合、右端に位置を調整
      if (this.contextMenuPosition.x + menuWidth > windowWidth) {
        this.contextMenuPosition.x = windowWidth - menuWidth;
      }

      // メニューが画面下端を越える場合、下端に位置を調整
      if (this.contextMenuPosition.y + menuHeight > windowHeight + scrollY) {
        this.contextMenuPosition.y = windowHeight + scrollY - menuHeight;
      }
    },
    openDeleteDialog(item) {
    if (item.screenName === '営業対象者画面') {
      alert('この画面は削除できません。');
      return;
    }
    this.deletePassword = '';
    this.deleteDialog = true;
  },
    confirmDeleteWithPassword() {
    const password = this.deletePassword;
    this.deleteDialog = false;
    this.handleDelete(password);
  },
    // 削除処理
    async handleDelete(password) {
      if (this.selectedItem.screenName === "営業対象者画面") {
        this.showAlert();
      } else {
        console.log(this.selectedItem)
        const screenId = this.selectedItem.screenId;
        this.selectedItem.iconVisible = false;
        this.authUserId = localStorage.getItem("authUserId");
        this.sessionKey = localStorage.getItem("sessionKey");
        this.staffName = localStorage.getItem("staffName");

        try {
          await deleteApi.deleteTaskList(screenId,password, this.authUserId, this.sessionKey, this.staffName);
          await this.getDataFromApi();
          eventBus.emit("refreshSidebar");
        } catch (error) {
          this.ErrMsg = "削除に失敗しました。\n" + error.message;
        }
      }
    },
    // 📌 日付を "YYYY/MM/DD" 形式に変換する関数
    formatDate(dateStr) {
      const dateObj = new Date(dateStr);
      return dateObj.toLocaleDateString("ja-JP", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },

    // 📌 作成日から何日前なのかを計算する関数
    getDaysAgo(date) {
      if (!date) return "日付不明"; // 📌 日付がない場合 "日付不明" を返す

      // 📌 日付を "YYYY/MM/DD" 形式に変換
      const updatedDateStr = this.formatDate(date);
      const currentDateStr = this.formatDate(new Date());

      console.log("入力された日付:", date, "➡ 変換後の日付:", updatedDateStr);
      console.log("現在の日付:", currentDateStr);

      // 📌 変換後の文字列を Date オブジェクトに再変換して比較
      const updatedDate = new Date(updatedDateStr);
      const currentDate = new Date(currentDateStr);

      const timeDiff = currentDate - updatedDate; // 📌 ミリ秒単位の差を計算
      const daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24)); // 📌 日単位に変換

      if (daysDiff === 0) {
        return "今日"; // 📌 今日なら "今日"
      } else if (daysDiff > 0) {
        return `${daysDiff}日前`; // 📌 N日前
      } else {
        return "日付不明"; // 📌 未来の日付または計算エラー時
      }
    },

  },
  computed: {
    containerStyle() {
      return {
        marginLeft: this.isSidebarClosed ? "0" : "15%",
        width: this.isSidebarClosed ? "100%" : "85%",
      };
    },
    filteredMenuItems() {
    const query = this.searchQuery?.toLowerCase() || '';
    if (!query) return this.menuItems;
    return this.menuItems.filter(
      (item) =>
        item.screenId !== null &&
        item.screenName &&
        item.screenName.toLowerCase().includes(query)
    );
  },
  },
};
</script>

<style scoped>
.header-section {
  margin-bottom: 0px;
  text-align: left;
}

h3 {
  margin-left: 40px;
  margin-top: 40px;
}

.search-field {
  color: blue;
  padding: 10px;
  width: 50%;
  max-width: 300px;
  font-size: 16px;
  position: absolute;
  top: 20px;
  margin-left: 800px;
}

.section-divider {
  margin-top: 50px;
  margin-bottom: 20px;
  background-color: #cccccc;
  z-index: 1;
}

.main-content {
  padding-top: 10px;
  margin-top: -40px;
}

.custom-card {
  border-radius: 8px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  height: 120px;
  cursor: pointer;
  transition: box-shadow 0.3s;
  align-items: center;
}

.custom-card:hover {
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.15);
}

.card-title {
  font-size: 16px;
}

.card-subtitle {
  font-size: 0.8rem;
  color: gray;
  margin-top: auto;
}
</style>
